import React, { useEffect } from 'react';
import '../styles/ubuntu2504.css';

const CheckIcon = () => (
  <svg className="check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 00-1.414 1.414l4 4a1 1 001.414 0l8-8a1 1 000-1.414z" clipRule="evenodd" />
  </svg>
);

const plans = [
  {
    name: "Ubuntu 25.04 U1",
    discount: "BETA",
    price: "$5.99",
    subtitle: "Test the bleeding edge with 25.04 Beta builds.",
    features: [
      "Ubuntu 25.04 Dev",
      "1 vCPU",
      "1GB RAM",
      "30GB SSD Storage",
      "Full Root Access",
      "IPv4 + IPv6",
      "1000GB Bandwidth",
      "Snapshot Ready",
      "DDoS Protection",
      "Instant Reinstall",
    ],
  },
  {
    name: "Ubuntu 25.04 U2",
    discount: "PERFORMANCE",
    price: "$9.99",
    subtitle: "Powerful dev VPS on the next Ubuntu generation.",
    features: [
      "Ubuntu 25.04 Dev",
      "2 vCPU",
      "2GB RAM",
      "100GB SSD Storage",
      "Full Root Access",
      "IPv4 + IPv6",
      "3500GB Bandwidth",
      "Snapshot Ready",
      "DDoS Protection",
      "Instant Reinstall",
    ],
  },
  {
    name: "Ubuntu 25.04 U3",
    discount: "MAXED OUT",
    price: "$15.49",
    subtitle: "Top-tier future-ready VPS with experimental edge.",
    features: [
      "Ubuntu 25.04 Dev",
      "4 vCPU",
      "4GB RAM",
      "200GB SSD Storage",
      "Full Root Access",
      "IPv4 + IPv6",
      "7000GB Bandwidth",
      "Snapshot Ready",
      "DDoS Protection",
      "Instant Reinstall",
    ],
  },
];

function Ubuntu2504() {
  useEffect(() => {
    document.body.classList.add('ubuntu2504-page');
    return () => {
      document.body.classList.remove('ubuntu2504-page');
    };
  }, []);

  return (
    <div className="pricing-section">
      <div className="pricing-wrapper">
        {plans.map((plan, index) => (
          <div className="pricing-card" key={index}>
            <div className="discount-badge">{plan.discount}</div>
            <h2>{plan.name}</h2>
            <p className="plan-subtitle">{plan.subtitle}</p>
            <p className="plan-price">
              <span className="price-label">Starting from</span><br />
              <span className="price-amount">{plan.price}<span className="per-month">/mo</span></span>
            </p>
            <a href="#" className="start-btn" target="_blank" rel="noopener noreferrer">START NOW</a>
            <div className="divider"></div>
            <ul className="feature-list">
              {plan.features.map((feature, i) => (
                <li key={i}><CheckIcon /> {feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Ubuntu2504;
